import styled, { css } from "styled-components";

const StyledFormControl = styled.div`
  &.fullWidth {
    width: 100%;
  }

  &.long {
    flex: 0 0 360px;
    max-width: 360px;
  }

  &.medium {
    flex: 0 0 170px;
    max-width: 170px;
  }

  &.tiny {
    flex: 0 0 85px;
    max-width: 85px;
  }

  &.no-label {
    padding-top: 26px;
  }
`;

const StyledFormLabelWrapper = styled.div`
  margin-bottom: ${(props) => props.theme.spacing(1)};
  display: flex;
  align-items: center;
  z-index: 1;

  label {
    display: flex;
    align-items: center;
    font-weight: 300;
    margin: 0;
    color: ${(props) => props.theme.palette.text.primary};
  }
`;
const StyledFormInput = styled.div`
  & > div {
    display: flex;
  }
`;

const StyledValidationText = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.palette.error.main};
  min-height: 20px;
`;

const FullHeightForm = styled.form`
  height: 100%;
`;

/**
 * Look of an outlined picker, shared by the Select (Components/Shared/Inputs/Dropdown) and the country
 * Autocomplete so the two kinds of pickers match side by side in a form. Apply on the MUI OutlinedInput
 * root: white box, divider-coloured border at rest, state colours on hover/focus/error, greyed when disabled.
 */
const outlinedPickerStyles = css`
  padding: 0;
  background-color: #fff;

  .MuiInputBase-input {
    padding: ${(props) => props.theme.spacing(3, 4)};
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.palette.divider};
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.palette.text.primary};
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.palette.primary.main};
  }

  &.Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.palette.error.main};
  }

  &.Mui-disabled {
    background-color: ${(props) => props.theme.colors.gray}80;

    .MuiOutlinedInput-notchedOutline {
      border-color: ${(props) => props.theme.palette.divider};
    }
  }
`;

/** The expand arrow of a picker, sized and dimmed the same in every picker. */
const pickerArrowStyles = css`
  svg {
    width: 18px;
    height: auto;
    opacity: 0.5;
  }
`;

export {
  StyledFormControl,
  StyledFormInput,
  StyledFormLabelWrapper,
  StyledValidationText,
  FullHeightForm,
  outlinedPickerStyles,
  pickerArrowStyles,
};
